import { render, staticRenderFns } from "./FatalError.vue?vue&type=template&id=0cf327b4&"
import script from "./FatalError.vue?vue&type=script&lang=js&"
export * from "./FatalError.vue?vue&type=script&lang=js&"
import style0 from "./FatalError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports